import React from "react";
import {
  NewBox as Box,
  NewTable as Table,
  NewTypography as Typography,
  NewGrade as Grade,
} from "@bca/ui-library";

import { BatteryGradeDataItem, BatteryGradesData } from "./BatteryGradesData";
import getBatteryGradeLetter from "../../../utilities/getBatteryGradeLetter";
import { useFeatureFlags } from "bca-feature-flag-provider";

interface BatteryGradesTableProps {
  batteryGrade: number | null;
}

const BatteryGradesTable: React.FC<BatteryGradesTableProps> = ({
  batteryGrade,
}) => {
  const { featureFlags } = useFeatureFlags();
  const { evBatteryExplainerCopy = false } = featureFlags;

  const getBatteryGradeScore = (
    batteryGrade: number,
    gradeItem: BatteryGradeDataItem
  ) => {
    const gradeLetter = getBatteryGradeLetter(batteryGrade);
    const isGradeMatch = gradeLetter === gradeItem.grade.toLowerCase();

    if (batteryGrade === null && isGradeMatch) {
      return "-";
    }

    return isGradeMatch ? batteryGrade : "";
  };

  const getVehicleScoreLabel = (gradeItem: BatteryGradeDataItem) => {

    if (evBatteryExplainerCopy && gradeItem.grade === "X") {
      return "Below 50/issue detected";
    }

    return gradeItem.scoreLabel
  }

  return (
    <Table width="100%">
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>BCA grade</Table.HeadCell>
          <Table.HeadCell>
            {evBatteryExplainerCopy
              ? "AVILOO State of Health % range"
              : "AVILOO scoring system"}
          </Table.HeadCell>
          <Table.HeadCell>Vehicle score</Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {BatteryGradesData.map((gradeItem) => (
          <Table.Row key={gradeItem.grade}>
            <Table.DataCell>
              <Box display="flex">
                <Grade value={getBatteryGradeLetter(gradeItem.exampleScore)} />
                <Typography marginLeft="md" weight="heavy">
                  {gradeItem.grade}
                </Typography>
              </Box>
            </Table.DataCell>
            <Table.DataCell>
              <Typography weight="heavy">{getVehicleScoreLabel(gradeItem)}</Typography>
            </Table.DataCell>
            <Table.DataCell>
              <Typography weight="heavy">
                {getBatteryGradeScore(batteryGrade, gradeItem)}
              </Typography>
            </Table.DataCell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default BatteryGradesTable;
